const getBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return {
      base_url: 'http://localhost:3003',
      customer_app_api_base_url: "http://localhost:9010"
    };
  } else {
    return {
      base_url: window.location.origin + "/api",
      customer_app_api_base_url: "https://careipro.com:9000"
    };
  }
};
export const { base_url, customer_app_api_base_url } = getBaseUrl();
export const ASSETS_URL = 'https://careipro.com/assets/';
export const API_LOGIN = `${base_url}/authentication/login`;
export const API_LOGOUT = `${base_url}/api/logout`;
export const DOCTORS_LIST_API = `${base_url}/doctor/doctors-list`;
export const UNAPPROVED_DOCTORS_LIST_API = `${base_url}/doctor/un-approve-doctors`;
export const DOCTORS_SETTINGS_API = `${base_url}/doctor/doctor-settings`;
export const TOTAL_SUMMARY_API = `${base_url}/report/total-summary`;
export const BOOKED_APOINTMENTS_API = `${base_url}/appointment/booked-appointments`;
export const SEARCH_SUGGESTION_API = `${base_url}/api/search`;
export const PATIENT_AUTOSUGGEST_API = `${base_url}/api/patient-autosuggest`;
export const ADD_PATIENT_API = `${base_url}/api/add-patient`;
export const PATIENTS_LIST_API = `${base_url}/api/patients-list`;
export const NEARBY_CITIES_API = `${base_url}/api/nearby-cities`;
export const SEARCH_AREA_API = `${base_url}/api/search-area`;
export const BOOK_APPOINTMENT_API = `${base_url}/appointment/book-appointment`;
export const BOOK_APPOINTMENT_BY_PATIENT_API = `${base_url}/appointment/book-appointment-by-patient`;
export const REBOOK_APPOINTMENT_API = `${base_url}/appointment/rebook-appointment`;
export const REBOOK_APPOINTMENT_BY_PATIENT_API = `${base_url}/appointment/rebook-appointment-by-patient`;
export const ON_BOOK_APPOINTMENT_SUCCESS = `${customer_app_api_base_url}/customer-app/on-appointment-booked`;
export const DOCTOR_RATING_REVIEWS_SUMMARY = `${base_url}/doctor/doctor-rating-reviews-summary`;
export const APPOINTMENTS_API = `${base_url}/appointment/appointments`;
export const TODAYS_PATIENTS = `${base_url}/appointment/todays-patients`;
export const GET_CONSULTED_DATES = `${base_url}/appointment/get-consulted-dates`;
export const PATIENTS_SUMMARY_API = `${base_url}/report/patients-summary`;
export const RECENT_REVIEWS_API = `${base_url}/api/recent-reviews`;
export const ALL_REVIEWS_API = `${base_url}/api/all-reviews`;
export const REPLY_REVIEW_API = `${base_url}/api/reply-review`;
export const MAKE_PUBLIC_REVIEW_API = `${base_url}/api/make-public-review`;
export const GENERATE_APPOINTMENT_REVIEW_REPORT_API = `${base_url}/api/generate-appointment-review-report`;
export const GET_APPOINTMENT_REVIEW_REPORT_API = `${base_url}/api/get-appointment-review-report`;
export const DOCTOR_COMPLETE_DETAILS_API = `${base_url}/doctor/doctor-complete-details`;
export const ADD_DOCTOR_API = `${base_url}/doctor/add-doctor`;
export const GET_DOCTOR_INFO = `${base_url}/doctor/doctor-info`;
export const SAVE_DOCTOR_INFO = `${base_url}/doctor/save-doctor-info`;
export const GET_CONSULT_DATE = `${base_url}/doctor/fetch-consult-date`;
export const GET_CONSULT_DATES = `${base_url}/doctor/fetch-consult-dates`;
export const UPDATE_EMERGENCY_BOOKING_CLOSE = `${base_url}/doctor/emergency-booking-close`;
export const DEFAULT_REMINDER_DAYS = `${base_url}/doctor/default-reminder-days`;
export const UPDATE_PAYMENT_STATUS = `${base_url}/appointment/update-payment-status`;
export const UPDATE_CONSULT_STATUS = `${base_url}/appointment/update-consult-status`;
export const UPDATE_TAGS = `${base_url}/appointment/update-tags`;
export const UPDATE_PATIENT_INFO = `${base_url}/appointment/update-patient-info`;
export const SEND_CONSUTING_TIME_CHANGE_SMS=`${base_url}/appointment/send-consulting-time-changed-sms`;
export const CONSULT_DATE_CHANGED=`${base_url}/appointment/consult-date-changed`;
export const ADD_RX_MEDICINE = `${base_url}/appointment/add-rx-medicine`;
export const SEARCH_OTP_API = `${base_url}/api/search-otp`;
export const GET_CLINIC_DETAIL_PAGE_URL_API =  `${base_url}/api/get-detail-page-link`;
export const UPDATE_DOCTOR_PROFILE_PIC =
  'https://careipro.com:9000/site-management/update-clinic-profile-pic';
export const GET_CACHE_STATUS_API = `${base_url}/api/get-cache-status`;
export const PRESCRIPTION_PRINT_SETTINGS_API = `${base_url}/api/prescription-print-settings`;
export const REMOVE_PRESCRIPTION_PRINT_OVERRIDE_API = `${base_url}/api/remove-prescription-print-override`;
export const CLEAR_CLINIC_MANAGEMENT_CACHE_API = `${base_url}/api/clear-clinic-management-cache`;
export const GET_STAFFS_LIST_API = `${base_url}/staff/list`;
export const START_DUTY_API = `${base_url}/attendance/start-duty`;
export const END_DUTY_API = `${base_url}/attendance/end-duty`;
export const MY_ATTENDANCE_API = `${base_url}/attendance/my-attendance`;
export const STAFF_ATTENDANCE_API = `${base_url}/attendance/staff-attendance`;
export const ADMIN_MARK_ATTENDANCE_API = `${base_url}/attendance/admin-mark-attendance`;
export const APPLY_LEAVE_API = `${base_url}/attendance/apply-leave`;
export const MY_LEAVES_API = `${base_url}/attendance/my-leaves`;
export const LEAVE_REQUESTS_API = `${base_url}/attendance/leave-requests`;
export const REVIEW_LEAVE_API = `${base_url}/attendance/review-leave`;
export const DUTY_SETTINGS_API = `${base_url}/attendance/duty-settings`;
export const SAVE_DUTY_SETTINGS_API = `${base_url}/attendance/save-duty-settings`;
export const BLOCKED_NUMBERS_API = `${base_url}/blocked-number/list`;
export const SAVE_BLOCKED_NUMBER_API = `${base_url}/blocked-number/save`;
export const REMOVE_BLOCKED_NUMBER_API = `${base_url}/blocked-number/remove`;
export const ADD_NEW_STAFF_API = `${base_url}/staff/add-new-staff`;
export const UPDATE_STAFF_RESTRICTED_SECTIONS_API = `${base_url}/staff/update-restricted-sections`;
export const WALLET_BALANCE_API = `${base_url}/wallet/balance`;
export const WALLET_TRANSACTIONS_API = `${base_url}/wallet/transactions`;
export const WALLET_TOPUP_INITIATE_API = `${base_url}/wallet/topup/initiate`;
export const WALLET_TOPUP_VALIDATE_API = `${base_url}/wallet/topup/validate`;
export const WALLET_INVOICES_API = `${base_url}/wallet/invoices`;
export const WALLET_INVOICE_RESPOND_API = `${base_url}/wallet/invoices/respond`;
